import { createPropStyling } from '../privatePropStylingUtils';
export const layoutCssAttrNames = ['boxSizing', 'display', 'height', 'maxHeight', 'maxWidth', 'minHeight', 'minWidth', 'overflow', 'overflowWrap', 'overflowX', 'overflowY', 'verticalAlign', 'width'];
export const layoutCssAttrAliases = {
  h: 'height',
  w: 'width'
};
export const layoutPropStyling = createPropStyling(layoutCssAttrNames, layoutCssAttrAliases);
//# sourceMappingURL=layoutPropStyling.js.map